const PublicBookingPageStrings = {
  en: {
    loading: "Loading booking details...",
    error: "Error",
    goHome: "Go to Home",
    pageTitle: "📅 Book Office Hours",
    subtitle: "You've been invited to book an office hours session",
    bookingDetails: "Booking Details",
    teachingAssistant: "Teaching Assistant",
    dayTime: "Day & Time",
    location: "Location",
    capacity: "Capacity",
    student: "student",
    students: "students",
    perSession: "per session",
    welcomeBack: "Welcome back",
    proceedToBook: "Proceed to Book This Slot",
    loginPrompt: "Please login or create an account to book this office hours session",
    loginButton: "Login to Book",
    or: "or",
    registerButton: "Create Account",
    invalidLink: "Invalid booking link. Missing instructor or slot information.",
    slotUnavailable: "The requested time slot is no longer available.",
    loadError: "Unable to load booking details. The link may be invalid or expired.",
  },
  ar: {
    loading: "جارٍ تحميل تفاصيل الحجز...",
    error: "خطأ",
    goHome: "العودة للرئيسية",
    pageTitle: "📅 حجز الساعات المكتبية",
    subtitle: "تمت دعوتك لحجز جلسة ساعات مكتبية",
    bookingDetails: "تفاصيل الحجز",
    teachingAssistant: "المعيد",
    dayTime: "اليوم والوقت",
    location: "الموقع",
    capacity: "السعة",
    student: "طالب",
    students: "طلاب",
    perSession: "لكل جلسة",
    welcomeBack: "مرحباً بعودتك",
    proceedToBook: "المتابعة لحجز هذا الموعد",
    loginPrompt: "يرجى تسجيل الدخول أو إنشاء حساب لحجز جلسة الساعات المكتبية هذه",
    loginButton: "تسجيل الدخول للحجز",
    or: "أو",
    registerButton: "إنشاء حساب",
    invalidLink: "رابط حجز غير صالح. معلومات المعيد أو الموعد مفقودة.",
    slotUnavailable: "الموعد المطلوب لم يعد متاحاً.",
    loadError: "تعذر تحميل تفاصيل الحجز. قد يكون الرابط غير صالح أو منتهي الصلاحية.",
  }
};

export default PublicBookingPageStrings;
